import { createContext, useContext, ReactNode } from 'react';

import { useParticles } from './particles.hooks';
import { ParticleContextValue } from './particles.types';

type Props = {
  children: ReactNode;
};

const ParticlesContext = createContext({} as ParticleContextValue);

export const useParticlesContext = () => useContext(ParticlesContext);

export const Particles = ({ children }: Props) => {
  const { contextValue, containerHtmlId } = useParticles();

  return (
    <ParticlesContext.Provider value={contextValue}>
      {children}
      <div id={containerHtmlId} />
    </ParticlesContext.Provider>
  );
};
